export { default } from './SkeletonMonthlyHistogramMobile';
